import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Row, Col, Switch, Checkbox, DatePicker, Select, ConfigProvider } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { toast, ToastContainer } from 'react-toastify';
import { Container } from 'react-bootstrap';
import ViewSupport from './ViewSupport';
import { IoMdCloseCircle } from 'react-icons/io';

const Support = ({userType,userGroups}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isRequesting, setIsRequesting] = useState(false);

    const [supportTickets, setSupportTickets] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
    });

    const [selectedSupport, setSelectedSupport] = useState(null);

    const [filterEmail, setFilterEmail] = useState('');
    const [filterFromDate, setFilterFromDate] = useState(null);
    const [filterToDate, setFilterToDate] = useState(null);
    const [filterStatus, setFilterStatus] = useState(null);
    // const [authorizedPermissions, setAuthorizedPermissions] = useState({});

    const transformString = (input) => {
        if (!input) { return ''; }
        let transformed = input.replace(/-/g, ' ');
        transformed = transformed.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        return transformed;
    };

    const makeTag = (value) => {
        switch (value) {
            case 'high':
                return <span className={`${styles['tag']} ${styles[value]}`}>High</span>;
            case 'medium':
                return <span className={`${styles['tag']} ${styles[value]}`}>Medium</span>;
            case 'low':
                return <span className={`${styles['tag']} ${styles[value]}`}>Low</span>;
            case 'open':
                return <span className={`${styles['tag']} ${styles[value]}`}>Open</span>;
            case 'closed':
                return <span className={`${styles['tag']} ${styles[value]}`}>Closed</span>;
            case 'rejected':
                return <span className={`${styles['tag']} ${styles[value]}`}>Rejected</span>;
            default:
                return <span className={`${styles['tag']} ${styles[value]}`}>{value}</span>;
        }
    };

    const formatDate = (dateString) => {
        const dateToConvert = new Date(dateString);
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };
        let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);
        return updatedFormat;
    }

    useEffect(() => {
        getSupportTickets();
        // handleAdminAuthorizedPermissions();

    }, []);

    // const handleAdminAuthorizedPermissions =  () => {
    //     try {
    //         if(userType === 'Breathe-Admin'){
    //             // console.log('Breathe Admin user ',userGroups);
    //             const resultantUserGroup = userGroups.find((userGroup)=>userGroup.groupName.includes('SupportAccessGroup'))
    //             setAuthorizedPermissions(JSON.parse(resultantUserGroup.permissions))
           
    //         }
           
    //     } catch (error) {
    //         console.error('Error in handling Admin resources authorization',error);
            
    //     } 
    // };

    const getSupportTickets = async (page = 1, pageSize = 10) => {
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getSupportTicketList({ page, limit: pageSize, filterEmail, filterFromDate, filterToDate, filterStatus });
            console.log(res);
            setSupportTickets(res.data.supportTickets);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
            setIsRequesting(false);
        } catch (error) {
            console.error(error);
            toast.error('Error fetching support tickets.');
        } finally {
            setIsLoading(false);
        }
    };

    const clearFilters = async () => {
        setFilterEmail(null);
        setFilterFromDate(null);
        setFilterToDate(null);
        setFilterStatus(null);
    }

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getSupportTickets(current, pageSize);
    };

    useEffect(() => {
        if (selectedSupport !== null) {
            console.log(selectedSupport);
        }
    }, [selectedSupport]);


    const handleDelete = async () => {
        try {
            setIsRequesting(true);
            console.log(selectedSupport?.record?._id);
            await BreathAPIs.deleteSupportTicket(selectedSupport?.record?._id);
            toast.success('Support ticket deleted successfully.');
            getSupportTickets(pagination.current, pagination.pageSize);
            setIsRequesting(false);
        } catch (error) {
            console.error(error);
            toast.error('Error deleting support ticket.');
        } finally {
            setSelectedSupport(null);
        }
    };

    const columnSupportTickets = [
        {
            title: 'Submitted by',
            width: 215,
            render: (text, record) => (
                <>
                    {record.userID.firstName} <i>({record.userID.email})</i>
                </>
            ),
        },
        {
            title: 'ID',
            width: 215,
            render: (text, record) => (<span onClick={() => setSelectedSupport({ record, type: 'view' })} className={styles['support-view']}>{record._id}</span>),
        },
        {
            title: 'Priority',
            width: 100,
            render: (text, record) => (makeTag(record.priority)),
        },
        {
            title: 'Type',
            width: 200,
            render: (text, record) => (transformString(record.mainIssueType)),
        },
        {
            title: 'Dated',
            width: 170,
            render: (text, record) => (formatDate(record.date)),
        },
        {
            title: 'Status',
            width: 170,
            render: (text, record) => (makeTag(record.status)),
        },
       
    ];

    const columnSupportTicketsActionObject =  {
        title: '',
        key: 'delete',
        width: 120,
        fixed: 'right',
        render: (text, record) => (
            <>
                <Button className='ms-2' shape="circle" danger onClick={() => setSelectedSupport({ record, type: 'delete' })}>
                    <AiFillDelete />
                </Button>
            </>
        ),
    }


    return (
        <Container>
            <ToastContainer />
            <Form layout={'vertical'}>
                <div className={`${styles['filter']} mb-4`}>
                    <div className={styles['filter-left']}><Input value={filterEmail} placeholder='Email: eg:example@email.com' onChange={(e) => setFilterEmail(e.target.value)} /></div>
                    <div className={styles['filter-right']}>
                        <DatePicker value={filterFromDate} placeholder='Start Date' onChange={(date) => setFilterFromDate(date)} />
                        <DatePicker value={filterToDate} placeholder='End Date' onChange={(date) => setFilterToDate(date)} />
                        <Select onChange={(e) => setFilterStatus(e)} value={filterStatus} placeholder={'Status'}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="open">Open</Select.Option>
                            <Select.Option value="closed">Closed</Select.Option>
                            <Select.Option value="rejected">Rejected</Select.Option>
                        </Select>
                        <Button onClick={() => { getSupportTickets() }} type="primary">Filter</Button>
                        <Button onClick={() => { clearFilters(); getSupportTickets() }} className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} />
                    </div>
                </div>
            </Form>
            <Table
                loading={isLoading}
                dataSource={supportTickets}
                columns={ (userType === 'Admin')?( columnSupportTickets.concat(columnSupportTicketsActionObject)) :columnSupportTickets}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                className={styles['data-list']}
                bordered
                size="middle"
                scroll={{ x: 'calc(600px + 50%)' }}
            />
            <ViewSupport
                modalVisible={selectedSupport?.type === 'view'}
                closeModal={() => { setSelectedSupport(null) }}
                selSupportInput={selectedSupport?.record}
                submitFeedback={() => { getSupportTickets(pagination.current, pagination.pageSize); }}
            />
            <Modal
                title="Confirm Deletion"
                visible={selectedSupport?.type === 'delete'}
                onOk={handleDelete}
                onCancel={() => setSelectedSupport(null)}
                okText="Yes, Delete"
                cancelText="Cancel"
                cancelButtonProps={{ disabled: isRequesting }}
                confirmLoading={isRequesting}
            >
                <p>Are you sure you want to delete this support ticket?</p>
            </Modal>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    userType: state.auth && state.auth.user ? state.auth.user.type : null,
    userGroups : state.auth && state.auth.user ? state.auth.user.userGroups : null

});

export default connect(mapStateToProps)(Support);
